import { axiosApi } from "../packages/axiosRequests";

export const namespaceList = ["south-africa", "kenya", "kuwait"];
export const typeList = [
  "CAR",
  "BAKKIE",
  "TRUCK",
  "MOTORBIKE",
  "TRAILER",
  "BUS",
  "PANELVAN",
];

export async function uploadDataChunk(chunk, namespace) {
  const {
    data: { data },
  } = await axiosApi.post(`/api/import/data/${namespace}`, chunk);
  return data;
}

export async function getDatas({ code, namespace }, { limit, page }) {
  const {
    data: {
      data,
      meta: { pagination },
    },
  } = await axiosApi.get(`/api/datas`, {
    params: {
      page: page,
      limit: limit,

      code: code,
      namespace: namespace,
    },
  });
  return {
    datas: data,
    pagination,
  };
}

export async function createData(values) {
  return axiosApi.post(`/api/data/create`, values);
}

export async function getDataById(id) {
  console.log(id);
  const { data } = await axiosApi.get(`/api/data/${id}`);
  return data;
}

export async function updateDataById(id, values) {
  return axiosApi.put(`/api/data/${id}`, values);
}

export async function deleteData(id) {
  return axiosApi.delete(`/api/data/${id}`);
}
